import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import CompatibilityIcon from 'marketplace-ui-common/compatibility/components/CompatibilityIcon';
import { getPricingUrl } from 'marketplace-ui-common/utils/urls';
import { useMemo } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureCompatibilityMessage = ({
  missingCompatibilityRequirement,
  onCompatibilityModalOpen,
  onTrackInteraction = () => {}
}) => {
  const {
    appContext
  } = useDetailsPageContext();
  const isCustomer = appContext === 'app';
  const {
    compatibilityType,
    requiredPlanHub,
    requiredPlan,
    multipleHubOptionsAvailable
  } = useMemo(() => {
    if (missingCompatibilityRequirement === 'USER_CONDITIONAL_SCOPE') {
      return {
        compatibilityType: 'COMPATIBLE_SOME'
      };
    } else if (missingCompatibilityRequirement === 'MULTIPLE_HUB_OPTIONS_AVAILABLE') {
      return {
        compatibilityType: 'COMPATIBLE_NONE',
        multipleHubOptionsAvailable: true
      };
    } else if (missingCompatibilityRequirement) {
      return {
        compatibilityType: 'COMPATIBLE_NONE',
        requiredPlanHub: missingCompatibilityRequirement.split('_')[0],
        requiredPlan: missingCompatibilityRequirement
      };
    } else {
      return {
        compatibilityType: 'COMPATIBLE_ALL'
      };
    }
  }, [missingCompatibilityRequirement]);
  const handleExplorePlanOptionsClick = () => {
    onTrackInteraction({
      action: 'click feature required compare by plan link'
    });
    if (onCompatibilityModalOpen) {
      onCompatibilityModalOpen();
    }
  };
  return /*#__PURE__*/_jsxs(MediaObject, {
    align: "start",
    itemLeft: isCustomer ? /*#__PURE__*/_jsx(CompatibilityIcon, {
      compatibilityType: compatibilityType
    }) : undefined,
    spacing: "extra-small",
    "data-test-id": "feature-card-compatibility",
    children: [multipleHubOptionsAvailable && onCompatibilityModalOpen ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `detailsPage.compatibility.features.COMPATIBLE_NONE_MULTIPLE_HUBS_jsx`,
      options: {
        linkProps: {
          onClick: handleExplorePlanOptionsClick
        }
      },
      elements: {
        Bold: 'b',
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `detailsPage.compatibility.features.${compatibilityType}_jsx`,
      options: {
        planName: requiredPlan ? I18n.text(`marketplace-ui-common.groupTags.tier.${requiredPlan}`) : '',
        linkProps: {
          external: true,
          href: getPricingUrl(appContext !== 'app', requiredPlanHub || ''),
          onClick: () => onTrackInteraction({
            action: 'click feature required plan compare by plan link',
            value: requiredPlanHub
          })
        }
      },
      elements: {
        Bold: 'b',
        Link
      }
    }), compatibilityType === 'COMPATIBLE_SOME' ? /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "detailsPage.compatibility.features.COMPATIBLE_SOME_help"
      }),
      marginInlineStart: "100"
    }) : undefined]
  });
};